import React, { useState, useEffect } from 'react';

const AvailabilityExceptions = ({ entityId, onSuccess, onCancel }) => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [exceptions, setExceptions] = useState([]);
  const [showForm, setShowForm] = useState(false);

  const [formData, setFormData] = useState({
    date: '',
    blockType: 'full', // full, partial, range
    startDate: '',
    endDate: '',
    times: 'all', // all أو مصفوفة أوقات محددة
    startTime: '',
    endTime: '',
    reason: ''
  });

  // جلب الاستثناءات الحالية
  useEffect(() => {
    fetchExceptions();
  }, [entityId]);

  const fetchExceptions = async () => {
    try {
      const token = localStorage.getItem('EntityTokenA');
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/entity/profile`,
        {
          headers: { 'Authorization': `Bearer ${token}` }
        }
      );

      if (response.ok) {
        const data = await response.json();
        
        if (data.availability_exceptions) {
          const parsed = typeof data.availability_exceptions === 'string'
            ? JSON.parse(data.availability_exceptions)
            : data.availability_exceptions;
          
          setExceptions(Array.isArray(parsed) ? parsed : []);
        }
      }
    } catch (err) {
      console.error('Error fetching exceptions:', err);
      setError('حدث خطأ في جلب البيانات');
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const resetForm = () => {
    setFormData({
      date: '',
      blockType: 'full',
      startDate: '',
      endDate: '',
      times: 'all',
      startTime: '',
      endTime: '',
      reason: ''
    });
    setShowForm(false);
  };

  const handleAddException = () => {
    setError('');
    setSuccessMessage('');

    // التحقق من البيانات
    if (formData.blockType === 'full' && !formData.date) {
      setError('يرجى اختيار التاريخ');
      return;
    }

    if (formData.blockType === 'range' && (!formData.startDate || !formData.endDate)) {
      setError('يرجى اختيار تاريخ البداية والنهاية');
      return;
    }

    if (formData.blockType === 'range' && formData.startDate > formData.endDate) {
      setError('تاريخ النهاية يجب أن يكون بعد تاريخ البداية');
      return;
    }

    if (formData.blockType === 'partial') {
      if (!formData.date) {
        setError('يرجى اختيار التاريخ');
        return;
      }
      if (!formData.startTime || !formData.endTime) {
        setError('يرجى تحديد وقت البداية والنهاية');
        return;
      }
      if (formData.startTime >= formData.endTime) {
        setError('وقت النهاية يجب أن يكون بعد وقت البداية');
        return;
      }
    }

    // إنشاء الاستثناء
    const newException = {
      id: Date.now(),
      blockType: formData.blockType,
      reason: formData.reason || 'غير متاح'
    };

    if (formData.blockType === 'full') {
      newException.date = formData.date;
      newException.times = 'all';
    } else if (formData.blockType === 'range') {
      newException.startDate = formData.startDate;
      newException.endDate = formData.endDate;
      newException.times = 'all';
    } else if (formData.blockType === 'partial') {
      newException.date = formData.date;
      newException.times = [formData.startTime, formData.endTime];
    }

    setExceptions(prev => [...prev, newException]);
    resetForm();
    setSuccessMessage('تم إضافة الاستثناء');
    setTimeout(() => setSuccessMessage(''), 3000);
  };

  const handleDeleteException = (exceptionId) => {
    if (window.confirm('هل أنت متأكد من حذف هذا الاستثناء؟')) {
      setExceptions(prev => prev.filter(ex => ex.id !== exceptionId));
      setSuccessMessage('تم حذف الاستثناء');
      setTimeout(() => setSuccessMessage(''), 3000);
    }
  };

  const handleSave = async () => {
    setError('');
    setSuccessMessage('');
    setSaving(true);

    console.log('exceptions  :' , exceptions);

    try {
      const token = localStorage.getItem('EntityTokenA');
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/EntityAvailability/availability`,
        {
          method: 'PUT',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ availability_exceptions: exceptions })
        }
      );

      const data = await response.json();

      console.log('Save response:', data);

      if (response.ok) {
        setSuccessMessage('تم حفظ الاستثناءات بنجاح');
        if (onSuccess) {
          setTimeout(() => onSuccess(data), 1500);
        }
      } else {
        setError(data.message || 'حدث خطأ في الحفظ');
      }
    } catch (err) {
      console.error('Error saving exceptions:', err);
      setError('حدث خطأ في الاتصال بالخادم');
    } finally {
      setSaving(false);
    }
  };

  const formatExceptionDisplay = (exception) => {
    let display = '';
    
    if (exception.blockType === 'full') {
      display = `📅 ${exception.date} - اليوم كامل`;
    } else if (exception.blockType === 'range') {
      display = `📅 من ${exception.startDate} إلى ${exception.endDate} - كامل الفترة`;
    } else if (exception.blockType === 'partial') {
      display = `📅 ${exception.date} - من ${exception.times[0]} إلى ${exception.times[1]}`;
    }

    return display;
  };

  if (loading) {
    return (
      <div className="flex-center p-8">
        <div className="spinner"></div>
        <p className="text-white mt-4">جاري التحميل...</p>
      </div>
    );
  }

  return (
    <div className="availability-exceptions">
      <h2 className="text-white text-2xl font-bold mb-6">
        🚫 إدارة الاستثناءات والأجازات
      </h2>

      <div className="glass p-6 mb-4">
        <p className="text-white opacity-80 text-sm mb-2">
          💡 حدد التواريخ التي لن يكون فيها حجز (أعياد، أجازات، مناسبات خاصة)
        </p>
        <p className="text-white opacity-80 text-sm">
          يمكنك منع الحجز في يوم كامل، فترة من الأيام، أو فترة محددة من يوم معين
        </p>
      </div>

      {/* زر إضافة استثناء */}
      <div className="mb-4">
        <button
          onClick={() => setShowForm(!showForm)}
          className="btn btn-primary"
        >
          {showForm ? 'إخفاء النموذج' : '+ إضافة استثناء جديد'}
        </button>
      </div>

      {/* نموذج الإضافة */}
      {showForm && (
        <div className="glass p-6 mb-6">
          <h3 className="text-white text-xl font-bold mb-4">إضافة استثناء جديد</h3>
          
          {/* نوع الاستثناء */}
          <div className="mb-4">
            <label className="text-white block mb-2">نوع الاستثناء</label>
            <select
              name="blockType"
              value={formData.blockType}
              onChange={handleInputChange}
              className="input"
            >
              <option value="full">يوم كامل</option>
              <option value="range">فترة من الأيام</option>
              <option value="partial">جزء من يوم</option>
            </select>
          </div>

          {/* حقول حسب نوع الاستثناء */}
          {formData.blockType === 'full' && (
            <div className="mb-4">
              <label className="text-white block mb-2">التاريخ</label>
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleInputChange}
                min={new Date().toISOString().split('T')[0]}
                className="input"
              />
            </div>
          )}

          {formData.blockType === 'range' && (
            <div className="grid grid-cols-2 gap-4 mb-4">
              <div>
                <label className="text-white block mb-2">من تاريخ</label>
                <input
                  type="date"
                  name="startDate"
                  value={formData.startDate}
                  onChange={handleInputChange}
                  min={new Date().toISOString().split('T')[0]}
                  className="input"
                />
              </div>
              <div>
                <label className="text-white block mb-2">إلى تاريخ</label>
                <input
                  type="date"
                  name="endDate"
                  value={formData.endDate}
                  onChange={handleInputChange}
                  min={formData.startDate || new Date().toISOString().split('T')[0]}
                  className="input"
                />
              </div>
            </div>
          )}

          {formData.blockType === 'partial' && (
            <>
              <div className="mb-4">
                <label className="text-white block mb-2">التاريخ</label>
                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={handleInputChange}
                  min={new Date().toISOString().split('T')[0]}
                  className="input"
                />
              </div>
              <div className="grid grid-cols-2 gap-4 mb-4">
                <div>
                  <label className="text-white block mb-2">من الساعة</label>
                  <input
                    type="time"
                    name="startTime"
                    value={formData.startTime}
                    onChange={handleInputChange}
                    className="input"
                  />
                </div>
                <div>
                  <label className="text-white block mb-2">إلى الساعة</label>
                  <input
                    type="time"
                    name="endTime"
                    value={formData.endTime}
                    onChange={handleInputChange}
                    className="input"
                  />
                </div>
              </div>
            </>
          )}

          {/* السبب */}
          <div className="mb-4">
            <label className="text-white block mb-2">السبب (اختياري)</label>
            <input
              type="text"
              name="reason"
              value={formData.reason}
              onChange={handleInputChange}
              placeholder="مثال: عيد الفطر، صيانة، إجازة..."
              className="input"
            />
          </div>

          {/* أزرار الإضافة */}
          <div className="flex gap-4">
            <button
              onClick={handleAddException}
              className="btn btn-primary flex-1"
            >
              إضافة
            </button>
            <button
              onClick={resetForm}
              className="btn btn-secondary"
            >
              إلغاء
            </button>
          </div>
        </div>
      )}

      {/* قائمة الاستثناءات */}
      <div className="glass p-6 mb-6">
        <h3 className="text-white text-xl font-bold mb-4">
          الاستثناءات الحالية ({exceptions.length})
        </h3>
        
        {exceptions.length === 0 ? (
          <p className="text-white opacity-70">لا توجد استثناءات</p>
        ) : (
          <div className="flex-column gap-3">
            {exceptions
              .sort((a, b) => {
                const dateA = a.date || a.startDate;
                const dateB = b.date || b.startDate;
                return new Date(dateA) - new Date(dateB);
              })
              .map((exception) => (
                <div key={exception.id} className="glass-dark p-4 rounded-lg">
                  <div className="flex-between">
                    <div className="text-white">
                      <p className="font-bold mb-1">
                        {formatExceptionDisplay(exception)}
                      </p>
                      {exception.reason && (
                        <p className="text-sm opacity-70">
                          💬 {exception.reason}
                        </p>
                      )}
                    </div>
                    <button
                      onClick={() => handleDeleteException(exception.id)}
                      className="btn btn-secondary"
                      style={{ padding: '6px 12px' }}
                    >
                      🗑️ حذف
                    </button>
                  </div>
                </div>
              ))}
          </div>
        )}
      </div>

      {/* الرسائل */}
      {error && (
        <div className="bg-red-500 bg-opacity-20 border border-red-500 rounded-lg p-3 mb-4">
          <p className="text-white text-sm">{error}</p>
        </div>
      )}

      {successMessage && (
        <div className="bg-green-500 bg-opacity-20 border border-green-500 rounded-lg p-3 mb-4">
          <p className="text-white text-sm">{successMessage}</p>
        </div>
      )}

      {/* أزرار الحفظ */}
      <div className="flex gap-4">
        <button
          onClick={handleSave}
          className="btn btn-primary flex-1"
          disabled={saving}
        >
          {saving ? (
            <div className="flex-center gap-2">
              <div className="spinner"></div>
              <span>جاري الحفظ...</span>
            </div>
          ) : (
            '💾 حفظ جميع الاستثناءات'
          )}
        </button>
        
        {onCancel && (
          <button
            onClick={onCancel}
            className="btn btn-secondary"
            disabled={saving}
          >
            إغلاق
          </button>
        )}
      </div>
    </div>
  );
};

export default AvailabilityExceptions;